module.exports = __webpack_public_path__ + "img/B925.aa35c9ad.jpg";